"use strict";
// TODO: all miscellaneous topics go here for now
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLIENT_API_GET_FEE = exports.CLIENT_API_GET_OTC = exports.CLIENT_API_POST_TRANSFER_ASSET = exports.TRANSFER_RESULT = void 0;
exports.TRANSFER_RESULT = "socket-transfer-result";
// POST REQUEST CONSTS
exports.CLIENT_API_POST_TRANSFER_ASSET = "/transfer-assets";
exports.CLIENT_API_GET_OTC = "/otc";
exports.CLIENT_API_GET_FEE = "/chain/fee";
//# sourceMappingURL=index.js.map